import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Portal, Backdrop, IconButton, Typography } from '@mui/material';

import { useResponsive } from '../../../../services/hooks';
import Iconify from '../../../../components/Iconify';
import { FullScreenView } from './age-range-details/FullScreenView';

const RootStyle = styled('div')(({ theme }) => ({
  right: 0,
  bottom: 0,
  zIndex: 1999,
  minHeight: 440,
  outline: 'none',
  display: 'flex',
  position: 'fixed',
  overflow: 'hidden',
  flexDirection: 'column',
  margin: theme.spacing(3),
  boxShadow: theme.customShadows.z20,
  borderRadius: Number(theme.shape.borderRadius) * 2,
  backgroundColor: theme.palette.background.paper
}));

export default function AgeRangeDetails({ isOpenCompose, onCloseCompose, data, submitCallback, allResorts, allSeasons }) {

  const isDesktop = useResponsive('up', 'sm');

  const handleClose = () => {
    onCloseCompose();
  };

  if (!isOpenCompose) {
    return null;
  }

  return (
    <Portal>
      <Backdrop sx={{ zIndex: 1998 }} open={true} />
      <RootStyle
        sx={{
          top: 0,
          left: 0,
          zIndex: 1999,
          margin: 'auto',
          width: {
            xs: 'calc(100% - 24px)',
            md: 'calc(100% - 20px)'
          },
          height: {
            xs: 'calc(100% - 24px)',
            md: 'calc(100% - 10px)'
          }
        }}
      >
        <Box
          sx={{
            pl: 3,
            pr: 1,
            height: 60,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Typography variant="h6">{data ? data.name : ''}</Typography>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <Iconify icon={'eva:close-fill'} width={20} height={20} />
          </IconButton>
        </Box>
        <FullScreenView
          data={data}
          submitCallback={submitCallback}
          handleClose={handleClose}
          allResorts={allResorts}
          allSeasons={allSeasons} />
      </RootStyle>
    </Portal>
  );
}
